import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import {
    CreateWorkflowCondition,
    UpdateWorkflowCondition,
    WorkflowCondition,
    WorkflowConditionListResponse
} from '@frontend/workflow/types';

export class WorkflowConditionClient extends APIClient {
    public static readonly endpoint = '/workflow-api/v1';

    public static async fetchAccountWorkflowStepConditions(
        accountId: string,
        workflowId: string,
        stepId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>
    ): Promise<WorkflowConditionListResponse> {
        return await this.apiPaginated<WorkflowConditionListResponse, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/workflows/${workflowId}/steps/${stepId}/conditions`,
            queryParams
        );
    }

    public static async postAccountWorkflowStepCondition(
        accountId: string,
        workflowId: string,
        stepId: string,
        condition: CreateWorkflowCondition
    ): Promise<WorkflowCondition> {
        const response = await this.post(
            `${this.endpoint}/accounts/${accountId}/workflows/${workflowId}/steps/${stepId}/conditions`,
            condition
        );
        return await this.handleResponse<WorkflowCondition>(response);
    }

    public static async patchAccountWorkflowStepCondition(
        accountId: string,
        workflowId: string,
        stepId: string,
        conditionId: string,
        condition: UpdateWorkflowCondition
    ): Promise<WorkflowCondition> {
        const response = await this.patch(
            `${this.endpoint}/accounts/${accountId}/workflows/${workflowId}/steps/${stepId}/conditions/${conditionId}`,
            condition
        );
        return await this.handleResponse<WorkflowCondition>(response);
    }

    public static async deleteAccountWorkflowStepCondition(
        accountId: string,
        workflowId: string,
        stepId: string,
        conditionId: string
    ): Promise<void> {
        const response = await this.delete(
            `${this.endpoint}/accounts/${accountId}/workflows/${workflowId}/steps/${stepId}/conditions/${conditionId}`
        );
        return await this.handleVoidResponse(response);
    }
}
